interface DestroyableEntity {
  id?: any;
  [key: string]: any;
}
interface DestroyParams {
  oldItems: DestroyableEntity[];
  formItems: (DestroyableEntity | null)[];
  keyName?: string;
  destroyValue?: '1' | true;
}

export const setDestroyItems = ({
  oldItems,
  formItems,
  keyName = 'destroy',
  destroyValue = '1'
}: DestroyParams) => {
  const removeItemsHash: Record<string, boolean> = {};
  const newItems = [...formItems];
  oldItems.forEach(item => {
    if (item?.id) removeItemsHash[item.id] = true;
  });
  newItems.forEach(item => {
    if (item?.id) {
      delete removeItemsHash[item.id];
    }
  });
  Object.keys(removeItemsHash).forEach(id => {
    newItems.push({ id: parseInt(id, 10), [keyName]: destroyValue });
  });
  return removeEmptyFields(newItems);
};

export const removeEmptyFields = (values: any) => {
  const isArray = Array.isArray(values);
  const result = isArray ? [] : {};
  if (typeof values === 'object' && values !== null) {
    for (const key in values) {
      if (values[key] || values[key] === 0 || typeof values[key] === 'boolean') {
        if (isArray) {
          (result as any[]).push(values[Number(key)]);
        } else {
          (result as Record<string, any>)[key] = values[key];
        }
      }
    }
    return result;
  }
  return values;
};

export const setValues = (object: any) => {
  if (object && typeof object !== 'string') {
    Object.keys(object).forEach(key => {
      if (Array.isArray(object[key])) {
        object[key] = object[key][0];
      } else setValues(object[key]);
    });
  }
};

export const getFieldName = (baseName: string | undefined, ...parts: string[]): string => {
  if (!baseName) return parts.join('.');
  return [baseName, ...parts].join('.');
};
export const addDestroy = (oldItem: any, newItem: any, keyName = 'destroy') => {
  if (oldItem && !newItem) return { [keyName]: '1' };
  return newItem;
};